import React, { useEffect, useState } from "react";
import { Typography, makeStyles, Button } from "@material-ui/core";
import { copyToClipboard } from "@/helpers/copyToClipboard";
import Modal from "../../components/Modal";
import { useTranslation } from "../../langs/useTranslation";
import { getGroupTokenApi, renewGroupTokenApi } from "@/apis/apiCollection";
import * as localforage from "localforage";
import { toast } from "@/apis/request";
import MemoedHOC from "@/hoc/MemoedHOC";
import { IconTitleDot } from "@/components/Icon";
import { GroupDeviceNamingConfigDatatable } from "@/helpers/GroupDeviceNamingConfigDatatable";

const useStyles = makeStyles(theme => ({
  item: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    display: "flex"
  },
  label: {
    marginRight: theme.spacing(1)
  },
  content: {
    padding: theme.spacing(2, 2),
    background: "#F8F9FC",
    borderRadius: 10,
    margin: theme.spacing(2, 0, 3)
  },
  top: {
    display: "flex",
    alignItems: "center"
  },
  footer: {
    display: "flex",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),

    "& .MuiButton-root": {
      backgroundColor: theme.palette.primary.opacity,
      color: theme.palette.primary.main,
      border: "none",
      marginRight: theme.spacing(2),
      width: 120,

      "&:hover": {
        backgroundColor: theme.palette.primary.opacityHover
      }
    }
  }
}));

function ViewGroupTokenModal({ groupId, groupName, open, onClose }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [groupToken, setGroupToken] = useState("");
  const [companyToken, setCompanyToken] = useState("");
  const [companyName, setCompanyName] = useState("-");

  const handleRenew = () => {
    renewGroupTokenApi({ groupId }).then(res => {
      setGroupToken(res.token || "-");
    });
  };

  const getTokenText = () => {
    // return `${companyToken}${groupToken}`;
    return `${groupToken}`;
  };

  const handleExport = () => {
    const JSONText = JSON.stringify(
      {
        companyToken,
        groupToken
      },
      null,
      1
    );
    const blob = new Blob([JSONText], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = "token.json";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  };

  useEffect(() => {
    if (open && groupId) {
      localforage.getItem("currentCompanyName").then(setCompanyName);
      getGroupTokenApi({ groupId }).then(res => {
        setCompanyToken(res.companyToken || "");
        if (!res.groupToken) {
          handleRenew();
        } else {
          setGroupToken(res.groupToken || "-");
        }
      });
    }
    return () => {
      setGroupToken("-");
      setCompanyToken("");
    };
  }, [groupId, open]);

  return (
    <Modal
      title={t({ id:'e2ys3T', defaultMessage: "门店配置信息" })}
      width={720}
      open={open}
      onClose={onClose}
      footer={null}
    >
      <div className={classes.item}>
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.label}
        >
          <IconTitleDot size="1.25rem" style={{ marginRight: 8 }} />
          {t({ defaultMessage: "公司" })}:
        </Typography>
        <Typography variant="body1">{companyName}</Typography>
      </div>
      <div className={classes.item}>
        <Typography
          variant="body1"
          color="textSecondary"
          className={classes.label}
        >
          <IconTitleDot size="1.25rem" style={{ marginRight: 8 }} />
          {t({ defaultMessage: "门店" })}:
        </Typography>
        <Typography variant="body1">{groupName}</Typography>
      </div>

      <div className={classes.content}>
        <div className={classes.top}>
          <Typography variant="body1" component="span">
            {t({ defaultMessage: "查看Token" })}：
          </Typography>
          <Typography variant="h5" color="primary" component="span">
            {groupToken}
          </Typography>
        </div>
        <div className={classes.footer}>
          <Button variant="outlined" color="primary" onClick={handleRenew}>
            {t({ defaultMessage: "更新Token" })}
          </Button>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              copyToClipboard(getTokenText()).then(() => {
                toast.success(t({ defaultMessage: "复制成功" }));
              });
            }}
          >
            {t({ defaultMessage: "复制" })}
          </Button>
          <Button variant="outlined" color="primary" onClick={handleExport}>
            {t({ defaultMessage: "导出JSON" })}
          </Button>
        </div>
      </div>

      <div className={classes.footerTable}>
        <Typography
          variant="body2"
          className={classes.label}
          style={{ marginBottom: 10, fontWeight: "bold" }}
        >
          {t({ defaultMessage: "门店关联的配置文件与命名规则" })}
        </Typography>
        <GroupDeviceNamingConfigDatatable groupId={groupId} />
      </div>
    </Modal>
  );
}

export default MemoedHOC(ViewGroupTokenModal);
